import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantEditPersonalPage = {
  alert: {
    error: 'coapplicant-edit-personal.form.alert.error',
  },
  footer: {
    root: 'coapplicant-edit-personal.footer.root',
  },
  form: {
    cancelButton: 'coapplicant-edit-personal.form.cancel-button',
    emailAddressInput: 'coapplicant-edit-personal.form.email-address-input',
    emailAddressInputError:
      'coapplicant-edit-personal.form.email-address-input-error',
    firstNameInput: 'coapplicant-edit-personal.form.first-name-input',
    firstNameInputError:
      'coapplicant-edit-personal.form.first-name-input-error',
    h1: 'coapplicant-edit-personal.form.h1',
    h2: 'coapplicant-edit-personal.form.h2',
    lastNameInput: 'coapplicant-edit-personal.form.last-name-input',
    lastNameInputError: 'coapplicant-edit-personal.form.last-name-input-error',
    phoneInput: 'coapplicant-edit-personal.form.phone-input',
    phoneInputError: 'coapplicant-edit-personal.form.phone-input-error',
    root: 'coapplicant-edit-personal.form.root',
    submitButton: 'coapplicant-edit-personal.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-edit-personal.header.drawer-button',
    previousStepButton: 'coapplicant-edit-personal.header.previous-step-button',
    root: 'coapplicant-edit-personal.header.root',
  },
  progress: {
    root: 'coapplicant-edit-personal.progress.root',
  },
} as const satisfies PageLocatorMap;
